import * as yup from 'yup'

export const templateChangeFormValidator = yup.object({
  collectDataTemplateId: yup.string().trim().required('Choose a template'),
})
